import { call, takeEvery, select } from 'redux-saga/effects';
import { get } from 'lodash';

import { BankStatementsConstants } from 'constants/bankStatementsConstants';
import { request } from 'components/Request';
import { BankStatementsUrls } from 'config/urls';

function* addDataVersionHeaderRequest(requestConfig, action) {
  const dataVersion = yield select(state => get(state, 'bankStatements.dataVersion'));

  yield call(request({
    ...requestConfig,
    headers: {
      ...requestConfig.headers,
      'X-LUSA-Data-Version': dataVersion,
    },
  }), action);
}

function* getStatements(action) {
  const { entityType, entityId, bankProcessorKey } = action.payload;
  yield call(request({
    type: BankStatementsConstants.GET_STATEMENTS,
    method: 'GET',
    url: BankStatementsUrls.get(entityType, entityId, bankProcessorKey),
  }), action);
}

function* processStatement(action) {
  const { entityType, entityId, bankProcessorKey } = action.payload;
  yield addDataVersionHeaderRequest({
    type: BankStatementsConstants.PROCESS_STATEMENT,
    method: 'POST',
    url: BankStatementsUrls.get(entityType, entityId, bankProcessorKey),
  }, action);
}

export default function* () {
  yield takeEvery(BankStatementsConstants.GET_STATEMENTS, getStatements);
  yield takeEvery(BankStatementsConstants.PROCESS_STATEMENT, processStatement);
}
